import { render, staticRenderFns } from "./ChooseOrUploadImage.vue?vue&type=template&id=1cf4d933&"
import script from "./ChooseOrUploadImage.vue?vue&type=script&lang=js&"
export * from "./ChooseOrUploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports